/**
 Provide/Inject is used across Vue components, and this doesn't work in js file,
 importI18n once from App.vue so that i18n can be accessed in js module.
 Usage:
 import {i18n} from "@/modules/i18n/i18n";
 i18n.t("foo") ==>  will output "bar" if {foo:"bar"} is set in language file
**/

let i18n;

const importI18n = (i18nInstance)=> {
    i18n = i18nInstance;
}

const changeLang = (value) => {
    if (value) {
        i18n.locale.value = value
    } else {
        i18n.locale.value = ( i18n.locale.value  === "zh") ? "en" : "zh"
    }

    document.title = i18n.t('label_doc_title');

}


export {i18n, importI18n, changeLang}